export const browserStorage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Ignore storage failures so UI state and auth flows can continue.
    }
  },

  remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore storage failures so cleanup paths remain safe.
    }
  },

  keys(): string[] {
    try {
      const result: string[] = [];
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key !== null) result.push(key);
      }
      return result;
    } catch {
      return [];
    }
  },
};
